import { Controller } from '@hotwired/stimulus';

import Local from '@/modules/local';
import ModuleLoader from '@/modules/module_loader';
import Searcher from '@/modules/searcher';
import Templates from '@/pages/site/templates';

Handlebars.registerPartial('address', Templates._address);
Handlebars.registerPartial('card_footer', Templates._card_footer);
Handlebars.registerPartial('event', Templates._event);
Handlebars.registerPartial('teacher', Templates._teacher);
Handlebars.registerPartial('unit', Templates._unit);

export default class extends Controller {
  connect() {
    const options = ModuleLoader.getOptions();

    new Searcher($('[data-gridy]'), Templates.searches.gridy, options.gridy).create();
    new Local().create();
  }
}
